import axios from 'axios';
import authHeader from "@/service/auth-header";

class AvailabilityService {

    async getCompanyAvailability(companyId) {
        return await axios.get(`/api/availability/${companyId}`,null)
    }

    async getBookingAvailability(companyId, locationId, practitionerId, billingPlanId) {
        const params = {
            locationId,
            billingPlanId
        };

        if (practitionerId) {
            params.practitionerId = practitionerId;
        }

        return await axios.get(
            `/api/availability/bookings/${companyId}`,
            { params }
        );
    }

    async getSpecificAvailability(availabilityId) {
        return await axios.get(`/api/availability/specific/${availabilityId}`,{ headers: authHeader() })
    }

    async createAvailability(companyId, data) {
        return await axios.post(`/api/availability/${companyId}`, data,{ headers: authHeader() });
    }

    async updateAvailability(availabilityId, data) {
        return await axios.put(`/api/availability/${availabilityId}`, data,{ headers: authHeader() });
    }

    async deleteAvailability(availabilityId) {
        return await axios.delete(`/api/availability/${availabilityId}`,{ headers: authHeader() })
    }

}

export default new AvailabilityService();
